<template>
  <div>
    <el-cascader
      :options="options"
      :filterable="true"
      :clearable="true"
      :disabled="disabled"
      v-model="datas"
      class="inputBox"
      :placeholder="placeholder"
      @change="change"
    >
    </el-cascader>
  </div>
</template>
<script>
let arr = {};
export default {
  data() {
    let _this = this;
    return {
      options: [],
      datas: _this.value,
    };
  },
  watch: {
    datas(newVal) {
      this.$emit("input", newVal);
      let contents = [];
      let filter = this.filter;
      for (let i in newVal) {
        contents[i] = filter(newVal[i]);
      }
      this.$emit("contents", contents);
    },
    value(newVal) {
      this.datas = newVal;
    },
  },
  mounted() {
    let _this = this;
    let name = _this.$parent.$vnode.tag;
    function loop(regions, arrs, level) {
      for (let i in regions) {
        let tmp = {
          label: regions[i]["label"],
          value: regions[i]["value"],
          item: regions[i]["item"],
        };
        arrs.push(tmp);
        if (regions[i].children && level < _this.initLevel) {
          tmp.children = [];
          loop(regions[i].children, tmp.children, level + 1);
        }
      }
    }
    if (!arr[name]) {
      arr[name] = {};
    }
    if (!arr[name][_this.initLevel]) {
      let infos = _this.infos;
      arr[name][_this.initLevel] = [];
      loop(infos, arr[name][_this.initLevel], 1);
    }
    _this.options = arr[name][_this.initLevel];
  },
  methods: {
    change(val) {
      this.$emit("change", val);
    },
  },
  props: {
    infos: {
      type: Array,
      default: () => [],
    },
    initLevel: {
      type: Number,
    },
    filter: {
      type: Function,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
  },
};
</script>
